export default __webpack_public_path__ + "static/ai-marketing-8--mobile-ef51353bfb62d52231f3d38746681717.png";